<template>
  <div>
    <div v-show="this.isApp == true ? false : true">
      <div class="activity-con" v-show="isShowAte == 1 ? true : false">
        <div class="close-activity"><div class="close" @click="closeActivity"><i class="el-icon-circle-close"></i></div></div>
        <div class="box1"></div>
      </div>
    </div>

    <div v-show="this.isApp == false ? false : true">
      <div class="activity-con" v-show="isShowAte == 1 ? true : false">
        <div class="close-activity-h5"><div class="close-h5" @click="closeActivity"><i class="el-icon-circle-close"></i></div></div>
        <div class="box1-h5"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
    //   isShowAte: true,
    };
  },
  computed:{
    ...mapState({
        isApp(state){
            return state.isApp
        },
        isShowAte(state){
            return state.activity
        }
    })
  },
  created() {

  },
  mounted(){
    console.log('isShowAte',this.isShowAte)
  },
  methods: {
    closeActivity(){
        this.$store.commit("setActivity", 0 )
    }
  },
};
</script>
<style lang="less" scoped>
.activity-con {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.685);
  z-index: 8888;
}
.close{
    position: fixed;
  top: 9.375rem;
  right: 6.25rem;
}
.el-icon-circle-close {
  color: #ffffff;
  font-size: 1.4375rem;
}
.box1 {
  position: fixed;
  margin: 0rem auto;
  top: 12.5rem;
  right: 0rem;
  left: 0rem;
  border: 0.0625rem solid #ffffff;
  width: 31.25rem;
  height: 31.25rem;
}

.activity-con-h5 {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.685);
  z-index: 8888;
}
.close-h5{
    position: fixed;
  top: 9.375rem;
  right: 1.875rem;
}
.box1-h5 {
  position: fixed;
  margin: 0rem auto;
  top: 12.5rem;
  right: 0rem;
  left: 0rem;
  border: 0.0625rem solid #ffffff;
  width: 22.5rem;
  height: 22.5rem;
}
</style>